export default function HeroSection() {
  return (
    <section id="hero" className="relative w-full min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20product%20photography%20flat%20lay%20with%20diverse%20fashion%20items%20sneakers%20handbags%20accessories%20watches%20and%20lifestyle%20products%20arranged%20artistically%20on%20warm%20cream%20surface%2C%20soft%20diffused%20natural%20lighting%20from%20large%20window%2C%20minimalist%20modern%20aesthetic%20with%20organic%20composition%2C%20neutral%20beige%20and%20warm%20cream%20tones%20throughout%2C%20professional%20editorial%20quality%20with%20gentle%20shadows%20and%20harmonious%20arrangement&width=1920&height=1080&seq=hero-bg-v2&orientation=landscape"
          alt="OOPBuy Spreadsheet product collection background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/45"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-4 md:px-6 pt-20 text-center">
        <div className="max-w-[900px] mx-auto">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight mb-6">
            OOPBuy Spreadsheet &mdash; The Ultimate Product Research &amp; Sourcing Database
          </h1>
          <p className="text-sm md:text-base text-white/80 max-w-[650px] mx-auto mb-4 leading-relaxed">
            Discover, analyze, and compare high-performing products using structured OOPBuy spreadsheets designed for modern e-commerce sellers.
          </p>
          <p className="text-xs md:text-sm text-white/60 max-w-[600px] mx-auto mb-10 leading-relaxed">
            The OOPBuy Spreadsheet system helps you quickly identify trending products, compare market data, and make smarter sourcing decisions using organized spreadsheet intelligence.
          </p>

          {/* Trust Line */}
          <div className="flex items-center justify-center gap-5 md:gap-8 mb-10 flex-wrap">
            <span className="text-xs text-white/60 whitespace-nowrap">
              <i className="ri-check-line mr-1 text-accent-400"></i>Updated regularly
            </span>
            <span className="text-xs text-white/60 whitespace-nowrap">
              <i className="ri-check-line mr-1 text-accent-400"></i>Data-driven insights
            </span>
            <span className="text-xs text-white/60 whitespace-nowrap">
              <i className="ri-check-line mr-1 text-accent-400"></i>Beginner friendly
            </span>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8">
            <a
              href="#categories"
              className="w-full sm:w-auto px-8 py-3 rounded-full border-2 border-white/80 text-white text-sm font-medium hover:bg-white/10 transition-all whitespace-nowrap cursor-pointer"
            >
              Explore Latest Spreadsheets
            </a>
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto px-8 py-3 rounded-full bg-accent-500 text-white text-sm font-medium hover:bg-accent-600 transition-all whitespace-nowrap cursor-pointer"
            >
              Access Full Product Database <i className="ri-arrow-right-line ml-1 align-middle"></i>
            </a>
          </div>

          {/* Main Site Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto px-10 py-4 rounded-full bg-white text-foreground-900 text-sm md:text-base font-semibold hover:bg-accent-50 transition-all shadow-lg whitespace-nowrap cursor-pointer"
            >
              OOPBuy Spreadsheet <i className="ri-arrow-right-up-line ml-2 align-middle"></i>
            </a>
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto px-10 py-4 rounded-full bg-foreground-800 text-white text-sm md:text-base font-semibold hover:bg-foreground-900 transition-all whitespace-nowrap cursor-pointer"
            >
              Buy It Now <i className="ri-shopping-bag-line ml-2 align-middle"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}